import type { Dtos, FredSyncRunId, USStateOrTerritory } from "@inrev/common";

export const fredQueryKey = () => ["fred"] as const;

export const fredSyncRunsQueryKey = () => [...fredQueryKey(), "sync-runs"] as const;

export const fredLatestSyncRunQueryKey = () => [...fredSyncRunsQueryKey(), "latest"] as const;

export const fredSyncRunQueryKey = (runId: FredSyncRunId | undefined) =>
	[...fredSyncRunsQueryKey(), runId ?? null] as const;

export const fredSnapshotQueryKey = (stateCode: USStateOrTerritory | undefined) =>
	[...fredQueryKey(), "snapshot", stateCode ?? null] as const;

export const fredSnapshotPeriodQueryKey = (
	stateCode: USStateOrTerritory | undefined,
	changePeriod: Dtos.MarketIntelligence.Fred.Snapshot.ChangePeriod,
) => [...fredSnapshotQueryKey(stateCode), changePeriod] as const;

export const fredSeriesQueryKey = (seriesCode: string) =>
	[...fredQueryKey(), "series", seriesCode] as const;

export const fredSeriesRangeQueryKey = (
	seriesCode: string,
	from: string | undefined,
	to: string | undefined,
) => [...fredSeriesQueryKey(seriesCode), from ?? null, to ?? null] as const;
